
	<div class="table-responsive design-table">
        <table class="table table-hover table-striped">
            <thead>
                <tr>
                    <th>User Name</th>
                    <th>Changed Date</th>
                    <th>Field Name</th>
                    <th>Old Value</th>
                    <th>New Value</th>                  
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let activity of ReportLogData">
                    <td>{{activity.UserName}}</td>
                    <td>
                        {{activity.ActivityDate | dateTimeFormat}}
                    </td>
                    <td>{{activity.Field}}</td>
                    <td style="max-width:300px">{{activity.oldValue}}</td>
                    <td style="max-width:300px">{{activity.newValue}}</td>
                    <!-- <td>{{activity.SourceId}}</td>                   
                    <td>{{activity.Module}}</td>                                      
                    <td>{{activity.IP}}</td> -->
                </tr>
            </tbody>
        </table>
        <div *ngIf="ReportLogData?.length === 0" class="no-record-found">No Records Found</div>
        <!-- <div>
            <pagination-controls (pageChange)="getServerData($event)"></pagination-controls>
        </div> -->
    </div>